import { getToken, onMessage } from 'firebase/messaging';
import { messaging, vapidKey } from '../firebase';
import { updateFCMToken } from './services/auth.service';

/**
 * Request permission and generate FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const generateFCMToken = async () => {
  try {
    // Request permission for notifications
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Get registration token
      const currentToken = await getToken(messaging, { 
        vapidKey: vapidKey 
      });
      
      if (currentToken) {
        
        // Save token to localStorage for later use
        localStorage.setItem('fcmToken', currentToken);
        let auth = localStorage.getItem('token');
        if(auth){
            await updateFCMToken(currentToken);
        }
        
        return currentToken;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};

/**
 * Get stored FCM token from localStorage
 * @returns {string|null} Stored FCM token or null
 */
export const getStoredFCMToken = () => {
  return localStorage.getItem('fcmToken');
};

/**
 * Handle foreground messages
 * @param {Function} callback - Callback function to handle the message
 */
export const onForegroundMessage = (callback) => {
  onMessage(messaging, (payload) => {
    // Note: Firebase messaging handles notifications automatically
    // Manual notification creation removed to prevent duplicates
    
    // Execute callback if provided
    if (callback && typeof callback === 'function') {
      callback(payload);
    }
  });
};

/**
 * Clear stored FCM token
 */
export const clearFCMToken = () => {
  localStorage.removeItem('fcmToken');
}; 